import { AttributeTypeDef } from '../generated/types'
import { StateMachineAttr } from '../attributes'

export function isStateMachineAttr(attr?: AttributeTypeDef): attr is StateMachineAttr {
    return attr?.value.valueType === 'stateMachine'
}
